// extracted by mini-css-extract-plugin
export default {"container":"style_container__J-lX4","background":"style_background__x10WF","text":"style_text__WfM9E"};